import {useTranslation} from "react-i18next";
import dayjs from "dayjs";

export const SignerPills = ({recipients}) => {
    const {t} = useTranslation();

    if (!recipients || recipients.length === 0) {
        return <p className="text-gray-400 text-sm">-</p>;
    }

    return (
        <div className="flex flex-wrap gap-2">
            {recipients.map((recipient) => {
                const isSigned = recipient.signingStatus === 'SIGNED';
                const isRejected = recipient.signingStatus === 'REJECTED';
                const isOpened = recipient.readStatus === 'OPENED';

                return (
                    <div
                        key={recipient.id}
                        className={`group relative px-3 py-1 rounded-full text-xs font-medium cursor-help transition-all ${
                            isSigned
                                ? 'bg-green-100 text-green-800 border border-green-300'
                                : isRejected
                                ? 'bg-red-100 text-red-800 border border-red-300'
                                : isOpened
                                ? 'bg-yellow-100 text-yellow-800 border border-yellow-300'
                                : 'bg-gray-100 text-gray-600 border border-gray-300'
                        }`}
                        title={recipient.email}
                    >
                        <span className="truncate max-w-[150px] inline-block">
                            {recipient.email}
                        </span>

                        <div className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-nowrap z-50 min-w-[200px]">
                            <div className="space-y-1">
                                <div><strong>{t('performance_reports.signer_name')}:</strong> {recipient.name}</div>
                                <div><strong>{t('performance_reports.signer_email')}:</strong> {recipient.email}</div>
                                {recipient.role && (
                                    <div><strong>{t('performance_reports.signer_role')}:</strong> {recipient.role}</div>
                                )}
                                <div>
                                    <strong>{t('performance_reports.signer_status')}:</strong> {
                                        isSigned ? `✓ ${t('performance_reports.signer_signed')}` :
                                        isRejected ? t('general.status.rejected') :
                                        isOpened ? t('performance_reports.signer_opened') :
                                        t('performance_reports.signer_not_opened')
                                    }
                                </div>
                                {recipient.signedAt && (
                                    <div><strong>{t('performance_reports.signer_signed_at')}:</strong> {dayjs(recipient.signedAt).format('DD/MM/YYYY HH:mm')}</div>
                                )}
                                {isRejected && recipient.rejectionReason && (
                                    <div><strong>{t('performance_reports.signer_rejection_reason')}:</strong> {recipient.rejectionReason}</div>
                                )}
                            </div>
                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
                                <div className="border-4 border-transparent border-t-gray-900"></div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
